import script from "./CFANavTop.vue?vue&type=script&setup=true&lang=js"
export * from "./CFANavTop.vue?vue&type=script&setup=true&lang=js"

import "./CFANavTop.vue?vue&type=style&index=0&id=3a3fe525&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a3fe525"]])

export default __exports__